


















































































































































































































































































































import { Component, Vue, Watch, Ref } from "vue-property-decorator";
import UserListSvc from "@/services/UserList";
import DokterSimrsSvc from "@/services/DokterSimrs";
import DrawingCanvas from "@/components/drawing-canvas/DrawingCanvasBlank.vue";
import UserPreferenceSvc, { UserPreference } from "@/services/UserPreference";
import {
  IGD_DEFAULT_STATUS_FILTER,
  IGD_STATUS_FILTER_OPTIONS,
  isIgdStatusFilterValue
} from "@/constants/igdStatus";
import ProfessionRoleSvc from "@/services/ProfessionRole";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";

@Component({
  beforeRouteEnter(to, from, next) {
    if (userModule.user.role?.id <= 2) {
      next();
    } else {
      appModule.sendErrorAlert("Halaman ini tidak bisa diakses...");

      next("/404");
    }
  },
  components: {
    DrawingCanvas
  }
})
export default class UserListPage extends Vue {
  @Ref() readonly drawcanv;

  list = [];
  dokterSimrs = [];
  userLoading = false;
  dialog = false;
  ttdActiveImage = "";
  activeUserId = "";
  signatureFile = null;
  signatureUploading = false;
  searchKey = "";
  options = {};
  ttdDrawedImage = "";
  userPrefDialog = false;
  showAutocompleteFreetext = true;
  callManualKlinik = true;
  savingUserPrefs = false;
  featureDownloadCPPT = false;
  featureEnableDashboard = false;
  igdStatusFilter = IGD_DEFAULT_STATUS_FILTER;
  igdStatusFilterOptions = IGD_STATUS_FILTER_OPTIONS;
  roleKey = null;
  profesiKey = null;
  profesiCatKey = null;

  // Assign profession-role (hak akses granular) — khusus Super Admin
  professionRoleDialog = false;
  professionRoleLoading = false;
  savingProfessionRoles = false;
  professionRoleUserId = "";
  professionRoleOptions: Array<{ id: string; name: string }> = [];
  selectedProfessionRoles: string[] = [];

  headers = [
    {
      text: "id",
      align: "start",
      sortable: false,
      value: "id"
    },
    {
      text: "Username",
      sortable: false,
      value: "username"
    },
    {
      text: "Nama",
      sortable: false,
      value: "identitas"
    },
    {
      text: "Profesi",
      sortable: false,
      value: "identitas.profesi"
    },
    {
      text: "Role",
      sortable: false,
      value: "role"
    },
    {
      text: "Mapping Dokter",
      sortable: false,
      value: "map_cdoc"
    },
    {
      text: "TTD",
      sortable: false,
      value: "signature"
    },
    {
      text: "Hak Akses",
      sortable: false,
      value: "profession_role"
    }
  ];

  drawedImage(img) {
    this.ttdDrawedImage = img;
  }

  clearSearch() {
    this.searchKey = "";
    this.getList();
  }

  async updateSignature() {
    this.signatureUploading = true;

    let resp = { status: null };

    if (this.signatureFile) {
      resp = await UserListSvc.updateSignature(
        this.activeUserId,
        this.signatureFile
      );
    } else if (this.ttdDrawedImage) {
      resp = await UserListSvc.updateSignatureBase64(
        this.activeUserId,
        this.ttdDrawedImage
      );
    }

    if (resp.status == 1) {
      this.dialog = false;
      this.getList();
      alert("Berhasil menambahkan tanda tangan!");
    }

    this.signatureUploading = false;
  }

  get userRole() {
    return userModule.user?.role;
  }

  get userList() {
    return this.list.map(user => {
      user.map_cdoc = user.map_cdoc
        ? user.map_cdoc
        : { user_id: user.id, c_doc_id: "" };

      user.role_id = user.role?.role_id ?? "";

      return user;
    });
  }

  mounted() {
    this.getDokterSimrsCombo().then(() => {
      this.getList();
    });
  }

  get roleOptions() {
    return [
      {
        id: 1,
        name: "Super Admin"
      },
      {
        id: 2,
        name: "Admin"
      },
      {
        id: 3,
        name: "User"
      },
      {
        id: 4,
        name: "Supervisor Mutu & PPI"
      }
      // {
      //   id: "",
      //   name: "?"
      // }
    ];
  }

  get roleViewOptions() {
    return [
      {
        id: null,
        name: "Semua"
      },
      ...this.roleOptions
    ];
  }

  get profesiOptions() {
    return ["Dokter", "Perawat", "Bidan", "Apoteker", "Perekam Medis", ""];
  }

  get profesiCategoryOptions() {
    return [
      {
        id: 0,
        name: "Semua"
      },
      {
        id: 1,
        name: "Dokter"
      },
      {
        id: 2,
        name: "Nakes Non-Dokter"
      },
      {
        id: 3,
        name: "Non-Nakes"
      }
    ];
  }

  get filterKeys() {
    return {
      nama: this.searchKey ?? undefined,
      role: this.roleKey ?? undefined,
      profesi_cat: this.profesiCatKey ?? undefined
    };
  }

  async getList() {
    this.userLoading = true;

    // const filter = this.searchKey ? { nama: this.searchKey } : null;
    const resp = await UserListSvc.getAll(this.filterKeys).finally(() => {
      this.userLoading = false;
    });

    this.list = resp;
  }

  async getDokterSimrsCombo() {
    const resp = await DokterSimrsSvc.getAll();

    this.dokterSimrs = resp;
  }

  async updateMapCdoc(id, docId) {
    const resp = await UserListSvc.updateMapCdoc(id, docId);

    return resp;
  }

  renderNama(nama) {
    return nama ?? "-";
  }

  changeSelectDokter(userId, docId) {
    this.updateMapCdoc(userId, { cdoc_id: docId }).then(resp => {
      if (resp.status == 1) {
        this.getList();
      } else {
        alert(resp.message);
      }
    });
  }

  changeUserRole(userId, roleId) {
    UserListSvc.updateUserRole(userId, { role_id: roleId }).then(resp => {
      if (resp.status == 1) {
        this.getList();
      } else {
        alert(resp.message);
      }
    });
  }

  showTtdDialog(userId, signature) {
    console.log(userId);

    if (signature) {
      this.ttdActiveImage = signature.image;
    }

    this.activeUserId = userId;

    this.dialog = true;
  }

  @Watch("dialog")
  changeDialogState(value) {
    if (!value) {
      this.ttdActiveImage = "";
      this.ttdDrawedImage = null;
      this.drawcanv.clearMode();
      this.activeUserId = "";
      this.signatureFile = null;
    }
  }

  showUserPrefDialog(userId) {
    this.userPrefDialog = true;
    this.activeUserId = userId;

    this.getUserPrefs(userId);
  }

  saveUserPrefs(userId) {
    if (!this.savingUserPrefs) {
      this.savingUserPrefs = true;

      UserPreferenceSvc.update(userId, this.userPrefsParam)
        .then(resp => {
          if (resp.status) {
            this.userPrefDialog = false;
          }
        })
        .finally(() => {
          this.savingUserPrefs = false;
        });
    }
  }

  userPrefs: UserPreference | null = null;

  userPrefsLoading = false;

  getUserPrefs(userId) {
    this.userPrefsLoading = true;

    UserPreferenceSvc.find(userId)
      .then(resp => {
        this.userPrefs = resp;

        console.log("get user prefs", resp);
      })
      .finally(() => {
        this.userPrefsLoading = false;
      });
  }

  @Watch("userPrefs")
  changeUserPrefs(val) {
    if (val) {
      this.showAutocompleteFreetext =
        val?.inputResep?.showAutocompleteFreeText ?? false;
      this.callManualKlinik =
        val?.callAntrianKlinik === "manual" ? true : false;
      this.featureDownloadCPPT = !!val?.feature?.downloadCPPT;
      this.featureEnableDashboard = !!val?.feature?.enableDashboard;
      this.igdStatusFilter = isIgdStatusFilterValue(
        val?.daftarPasienIgd?.statusFilter
      )
        ? String(val.daftarPasienIgd.statusFilter)
        : IGD_DEFAULT_STATUS_FILTER;
    }
  }

  @Watch("userPrefDialog")
  changeUserPrefDialog(val) {
    if (!val) {
      this.clearUserPrefsContent();
    }
  }

  clearUserPrefsContent() {
    this.showAutocompleteFreetext = true;
    this.callManualKlinik = true;
    this.featureDownloadCPPT = false;
    this.featureEnableDashboard = false;
    this.igdStatusFilter = IGD_DEFAULT_STATUS_FILTER;
    this.activeUserId = "";
  }

  get userPrefsParam() {
    return {
      inputResep: { showAutocompleteFreeText: this.showAutocompleteFreetext },
      callAntrianKlinik: this.callManualKlinik ? "manual" : "auto",
      feature: {
        downloadCPPT: this.featureDownloadCPPT,
        enableDashboard: this.featureEnableDashboard
      },
      daftarPasienIgd: { statusFilter: this.igdStatusFilter }
    };
  }

  async loadProfessionRoleOptions() {
    if (this.professionRoleOptions.length) return;
    this.professionRoleOptions = await ProfessionRoleSvc.list();
  }

  async showProfessionRoleDialog(userId) {
    this.professionRoleUserId = userId;
    this.professionRoleDialog = true;
    this.professionRoleLoading = true;

    try {
      await this.loadProfessionRoleOptions();
      const resp = await UserListSvc.getProfessionRoles(userId);
      const current = resp?.data ?? [];
      this.selectedProfessionRoles = current.map(r => r.id);
    } finally {
      this.professionRoleLoading = false;
    }
  }

  async saveProfessionRoles() {
    this.savingProfessionRoles = true;

    try {
      const resp = await UserListSvc.updateProfessionRoles(
        this.professionRoleUserId,
        this.selectedProfessionRoles
      );

      if (resp.status == 1) {
        this.professionRoleDialog = false;
        appModule.NoticeDelay("Hak akses (profession-role) tersimpan");
      }
    } finally {
      this.savingProfessionRoles = false;
    }
  }

  @Watch("professionRoleDialog")
  changeProfessionRoleDialog(val) {
    if (!val) {
      this.professionRoleUserId = "";
      this.selectedProfessionRoles = [];
    }
  }
}
